<template>
    <div>
        <v-card>
            <v-toolbar card prominent>
                <v-toolbar-title class="body-2 grey--text">{{ $t('subscription.title')}}</v-toolbar-title>
            </v-toolbar>
        </v-card>
        <v-card >
            <v-card-text>
                <v-layout row wrap justify-center class="white pa-3">
                    <v-flex xs12>
                       <div v-if="subscription">
                            <v-card >
                                <v-card-title >
                                    <v-layout row wrap>
                                        <v-flex xs12>
                                            <v-layout row wrap class="mb-1">
                                                <v-flex xs12>
                                                        <!-- Subscription title with recurring icon -->
                                                        <div>
                                                            <span class="overline grey--text text--darken font-weight-bold">
                                                                <v-icon small class="grey" color="white">$vuetify.icons.rms_sync</v-icon> {{ $t('subscription.title')}}
                                                            </span>
                                                        </div>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                        <v-flex xs12>
                                            <v-layout row wrap>
                                                <v-flex xs9>
                                                    <div class="text-truncate">
                                                        <span class="title font-weight-regular">
                                                            <span>{{ subscription.metadata.email }}</span>
                                                            <span class="subtitle-1 grey--text text--darken">&nbsp;{{ $t('subscription.on.title') }}&nbsp;</span>
                                                            <span>{{ $t('quickrights') }}&nbsp;•&nbsp;{{subscription.plan.nickname}}</span>
                                                            <!-- Subscription trial ends status -->
                                                            <v-chip class="mt-0 ml-2" color="blue lighten-4 primary--text font-weight-medium" small v-if="!(subscription.cancel_at && subscription.cancel_at_period_end) && DEFINES.SUBSCRIPTION.STATUS.TRIALING == subscription.status">
                                                                {{ $t('subscription.trial_ends.title')}}&nbsp;{{getRemainingTime() }}
                                                            </v-chip>
                                                            <!-- Subscription active status -->
                                                            <v-chip class="mt-0 ml-2" color="blue lighten-4 primary--text font-weight-medium" small v-if="!(subscription.cancel_at && subscription.cancel_at_period_end) && DEFINES.SUBSCRIPTION.STATUS.ACTIVE == subscription.status">
                                                                {{ subscription.status | capitalize }}
                                                            </v-chip>
                                                            <!-- Subscription canceld status -->
                                                            <v-chip class="mt-0 ml-2" color="default grey--text text--darken-2 font-weight-medium" small v-if="DEFINES.SUBSCRIPTION.STATUS.CANCELED == subscription.status">
                                                                {{subscription.status | capitalize }}
                                                            </v-chip>
                                                            <!-- Subscription cancels in status -->
                                                            <v-tooltip  top color="white" max-width="300" nudge-top="10" >
                                                                <template v-slot:activator="{ on }">
                                                                    <span v-if="subscription.cancel_at && subscription.cancel_at_period_end && !subscription.ended_at">
                                                                        <v-chip v-on="on" color="default" class="mt-0 ml-2 grey--text text--darken-2 font-weight-medium" small >
                                                                            <v-icon small color="grey darken-2" v-on="on">$vuetify.icons.rms_clock</v-icon>&nbsp;{{$t('subscription.cancels.title')}}&nbsp;{{ getRemainingTime()}}
                                                                        </v-chip>
                                                                    </span>
                                                                </template>
                                                                <div class="pa-2" >
                                                                    <span class="grey--text text--darken-3 body-1">{{ $t('subscription.cancel.message')}}</span>
                                                                </div>
                                                            </v-tooltip>
                                                        </span>
                                                    </div>
                                                </v-flex>
                                                <!-- Cancel / Reactivate-->
                                                <v-flex xs3 class="text-xs-right" v-if="!subscription.ended_at">
                                                    <!-- Cancel at period end -->
                                                    <ConfirmationDialog
                                                        :desc=" (!subscription.cancel_at_period_end) ? 'subscription.confirmation.cancel.description' : 'subscription.confirmation.reactivate.description'"
                                                        :action=" (!subscription.cancel_at_period_end) ? getDialogAction('cancel',false,'','error','rms.button.cancel','rms.button.cancel','rms.button.do_not_cancel') : getDialogAction('resume',false,'','success','rms.button.reactivate','rms.button.reactivate',null)"
                                                        :headline="(!subscription.cancel_at_period_end) ? 'subscription.confirmation.cancel.heading' : 'subscription.confirmation.reactivate.heading'"
                                                        :button_type="'button'"
                                                    ></ConfirmationDialog>
                                                    <!-- Immediate cancel -->
                                                    <ConfirmationDialog
                                                        :desc="'subscription.confirmation.cancel_now.description'"
                                                        :action="getDialogAction('cancelNow',true,'','error','rms.button.cancel_now','rms.button.cancel_now','rms.button.do_not_cancel')"
                                                        :headline="'subscription.confirmation.cancel_now.heading'"
                                                        :button_type="'button'"
                                                    ></ConfirmationDialog>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>



                                    </v-layout>
                                </v-card-title>
                                <v-divider></v-divider>
                                <v-card-text class="light-bg">
                                    <v-layout row wrap>
                                        <v-flex xs2 v-if="DEFINES.SUBSCRIPTION.STATUS.CANCELED != subscription.status">
                                            <div class="grey--text text--darken-1">{{ $t('subscription.next_invoice') }}</div>
                                            <div class="font-weight-medium">
                                                <span>{{$t('subscription.currency.'+subscription.plan.currency)}}</span>
                                                <span v-if="DEFINES.SUBSCRIPTION.STATUS.TRIALING == subscription.status">{{ (0).toFixed(2)}}</span>
                                                <span v-if="DEFINES.SUBSCRIPTION.STATUS.ACTIVE == subscription.status">
                                                    {{ (subscription.plan.tiers[0].flat_amount/100).toFixed(2) }}</span>
                                                <span>&nbsp;{{$t('subscription.on.title')}}&nbsp;</span>
                                                <span>{{ getFormattedTimeString(subscription.current_period_end, "D MMM") }}</span>
                                            </div>
                                        </v-flex>
                                        <v-flex xs3 >
                                            <div :class="[DEFINES.SUBSCRIPTION.STATUS.CANCELED != subscription.status ? 'borderLeft pl-3' : '', 'pr-3 displayInline']">
                                                <div class="grey--text text--darken-1">{{ $t('subscription.started') }}</div>
                                                <div>{{ getFormattedTimeString(subscription.created, "D MMM") }}</div>
                                            </div>
                                            <div class="borderLeft pl-3 displayInline" v-if="DEFINES.SUBSCRIPTION.STATUS.CANCELED == subscription.status" >
                                                <div class="grey--text text--darken-1">{{ $t('subscription.status.ended') }}</div>
                                                <div>{{ getFormattedTimeString(subscription.current_period_start,"D MMM") }}</div>
                                            </div>
                                            <div class="borderLeft pl-3 displayInline" v-if="subscription.canceled_at && subscription.cancel_at_period_end">
                                                <div class="grey--text text--darken-1">{{ $t('subscription.ends') }}</div>
                                                <div>{{ $t('subscription.ends_at_period_end') }}</div>
                                            </div>
                                        </v-flex>
                                    </v-layout>
                                </v-card-text>
                            </v-card>
                            <br>
                            <!-- Details -->
                            <v-card>
                                <v-card-title >
                                    <h3 class="font-weight-medium">{{ $t('subscription.details')}}</h3>
                                </v-card-title>
                                <v-divider></v-divider>
                                <v-card-text>
                                        <v-layout row wrap>
                                           <v-flex xs6 sm6 md4>
                                                <!-- Customer email -->
                                                <v-layout row wrap class="py-1">
                                                    <v-flex xs6 class="grey--text text--darken-1">{{ $t('subscription.customer')}}</v-flex>
                                                    <v-flex xs6>
                                                        <router-link class="primary--text font-weight-medium" :to="{name:'UserProfile'}" tag="span" exact :style="{ cursor: 'pointer'}">
                                                            {{ subscription.metadata.email }}
                                                        </router-link>
                                                    </v-flex>
                                                </v-layout>
                                                <!-- Customer name -->
                                                <v-layout row wrap class="py-1">
                                                    <v-flex xs6 class="grey--text text--darken-1">{{ $t('rms.field.name.label')}}</v-flex>
                                                    <v-flex xs6>{{ subscription.metadata.name }}</v-flex>
                                                </v-layout>
                                                <!-- Company Name -->
                                                <v-layout row wrap class="py-1">
                                                    <v-flex xs6 class="grey--text text--darken-1">{{$t('company.title')}}</v-flex>
                                                    <v-flex xs6>
                                                        <router-link class="primary--text font-weight-medium" :to="{name:'CompanyDashboard'}" tag="span" exact :style="{ cursor: 'pointer'}">
                                                            {{ subscription.metadata.company_name }}
                                                        </router-link>
                                                    </v-flex>
                                                </v-layout>
                                                <!-- Subscription Created -->
                                                <v-layout row wrap class="py-1">
                                                    <v-flex xs6 class="grey--text text--darken-1">{{ $t('subscription.created')}}</v-flex>
                                                    <v-flex xs6>{{ getFormattedTimeString(subscription.created, "D MMM, HH:MM") }}</v-flex>
                                                </v-layout>
                                                <!-- Current Period -->
                                            <v-layout row wrap class="py-1" >
                                                <!-- Label according to subscription status -->
                                                    <v-flex xs6 class="grey--text text--darken-1">
                                                        {{
                                                            (DEFINES.SUBSCRIPTION.STATUS.CANCELED != subscription.status && !subscription.cancel_at) ?
                                                            $t('subscription.current_period') :
                                                            (subscription.cancel_at && subscription.cancel_at_period_end) && !subscription.ends_at ?
                                                            $t('subscription.schedule_to_cancel.title') :
                                                            $t('subscription.ended_at.title')
                                                        }}
                                                    </v-flex>
                                                    <!-- When status is active or trialing but subscription not canceled -->
                                                    <v-flex xs6 v-if="DEFINES.SUBSCRIPTION.STATUS.CANCELED != subscription.status && !subscription.cancel_at">
                                                        {{ getFormattedTimeString(subscription.current_period_start, "D MMM") }}&nbsp;{{$t('subscription.to')}}&nbsp;{{ getFormattedTimeString(subscription.current_period_end,"D MMM")}}
                                                    </v-flex>
                                                    <!-- When status is active or trialing but subscription ending at period end -->
                                                    <v-flex xs6 v-else-if="(subscription.cancel_at && subscription.cancel_at_period_end) && !subscription.ends_at">
                                                        {{ getFormattedTimeString(subscription.current_period_end,"D MMM, HH:MM")}}
                                                    </v-flex>
                                                    <!-- When subscription has been canceled immediately -->
                                                    <v-flex xs6 v-else>
                                                        {{ getFormattedTimeString(subscription.ended_at, "D MMM, HH:MM") }}
                                                    </v-flex>
                                                </v-layout>
                                                <!-- Canceled At -->
                                                <v-layout row wrap class="py-1" v-if="DEFINES.SUBSCRIPTION.STATUS.CANCELED != subscription.status && subscription.canceled_at">
                                                    <v-flex xs6 class="red--text text--darken-1">{{ $t('subscription.canceled_at.title') }}</v-flex>
                                                    <v-flex xs6>{{ getFormattedTimeString(subscription.canceled_at, "D MMM, HH:MM") }}</v-flex>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex xs6 sm6 md4>
                                                <!-- Trialing until -->
                                                <v-layout row wrap class="py-1" v-if="subscription.trial_end">
                                                    <v-flex xs6 class="grey--text text--darken-1">{{ $t('subscription.trialing_until.title') }}</v-flex>
                                                    <v-flex xs6>
                                                        {{ getFormattedTimeString(subscription.trial_end, "D/MM") }}
                                                    </v-flex>
                                                </v-layout>
                                                <!-- Discount -->
                                                <v-layout row wrap class="py-1">
                                                    <v-flex xs6 class="grey--text text--darken-1">{{$t('subscription.discount')}}</v-flex>
                                                    <v-flex xs6>
                                                        {{ subscription.discount ? subscription.discount.coupon.percent_off+$t('subscription.percent_off')+subscription.discount.coupon.duration : $t('subscription.no_coupon')}}
                                                    </v-flex>
                                                </v-layout>
                                                <!-- Billing Method -->
                                                <v-layout row wrap class="py-1">
                                                    <v-flex xs6 class="grey--text text--darken-1">{{ $t('subscription.billing_method') }}</v-flex>
                                                    <v-flex xs6>
                                                        {{ paymentMethod.card.brand.toUpperCase() }}&nbsp;<span class="grey--text text--darken-1">|</span>&nbsp;●●●●●●●●{{ paymentMethod.card.last4}}
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                    </v-layout>
                                </v-card-text>
                            </v-card>
                            <!-- Plan -->
                            <br>
                            <v-card>
                                <v-card-title >
                                    <h3 class="font-weight-medium">{{ $t('subscription.pricing') }}</h3>
                                </v-card-title>
                                <v-divider></v-divider>
                                <v-card-text>
                                    <v-layout row wrap>
                                        <v-flex xs9>
                                            <div class="font-weight-medium">{{ $t('quickrights') }}&nbsp;•&nbsp;{{subscription.plan.nickname}}</div>
                                            <div class="grey--text text--darken-1">{{ getPlanFormat(subscription.plan.tiers)}}</div>
                                        </v-flex>
                                        <v-flex xs3 class="text-xs-right">
                                            <v-btn flat small color="blue" @click="usage_visible=true">{{ $t('subscription.usage.button.view_usage') }}</v-btn>
                                        </v-flex>
                                    </v-layout>
                                </v-card-text>
                            </v-card>
                            <!-- Invoices -->
                            <br>
                            <v-card>
                                <v-card-title >
                                    <h3 class="font-weight-medium">{{ $t('subscription.invoices') }}</h3>
                                </v-card-title>
                                <v-divider></v-divider>
                                <template v-if="invoices">
                                    <v-data-table :headers="headers" :items="invoices" class="elevation-1">
                                        <!-- Customized header -->
                                        <template v-slot:headers="props">
                                            <tr class="light-bg">
                                                <th
                                                v-for="header in props.headers"
                                                :key="header.text"
                                                :align="header.align"
                                                >
                                                {{ header.text }}
                                                </th>
                                            </tr>
                                        </template>
                                        <!-- Data Rows -->
                                        <template v-slot:items="props">
                                            <!-- Amount -->
                                            <td class="body-2 text-xs-left font-weight-medium height-zero">
                                                <!-- Converting cents into dollar by dividing 100-->
                                                {{$t('subscription.currency.'+props.item.currency)}}&nbsp;{{ (props.item.total/100).toFixed(2) }}
                                            </td>
                                            <!-- Invoice status -->
                                            <td class="body-2 text-xs-left height-zero">
                                               <v-chip v-if="DEFINES.SUBSCRIPTION.INVOICE.STATUS.PAID == props.item.status" color="blue lighten-4 primary--text font-weight-medium" small>
                                                    {{$t('subscription.invoice.status.paid')}}
                                                </v-chip>
                                                <v-chip v-if="DEFINES.SUBSCRIPTION.INVOICE.STATUS.DUE == props.item.status" color="orange lighten-4 deep-orange--text text--darken-3 font-weight-medium" small>
                                                    {{$t('subscription.invoice.status.due')}}
                                                </v-chip>
                                            </td>
                                             <!-- Invoice number -->
                                            <td class="body-2 text-xs-left height-zero">
                                                {{ props.item.number }}
                                            </td>
                                            <!-- Customer email -->
                                            <td class="body-2 text-xs-left height-zero">{{ props.item.customer_email }}</td>
                                            <!-- Invoice due date -->
                                            <td class="body-2 text-xs-left height-zero">
                                                {{ props.item.due_date ? moment.unix(props.item.due_date).format('D MMM') : '___' }}
                                            </td>
                                            <!-- Invoice created date -->
                                            <td class="body-2 text-xs-left height-zero" >
                                                {{ moment.unix(props.item.created).format('D MMM, HH:MM')}}
                                            </td>
                                             <!-- Paid at -->
                                            <td class="body-2 text-xs-left height-zero">
                                                {{ props.item.status_transitions.paid_at ? moment.unix(props.item.status_transitions.paid_at).format('D MMM, HH:MM') : '___'  }}
                                            </td>
                                            <!-- Invoice menu -->
                                            <td class="height-zero">
                                                <v-btn  color="blue" flat small :href="props.item.invoice_pdf" target="_blank">
                                                  {{ $t("subscription.invoice.download_pdf") }}
                                                </v-btn>
                                            </td>
                                        </template>
                                    </v-data-table>
                                </template>
                                <template v-else>
                                    <div class="text-xs-center subheading pa-5 grey--text darken-1">
                                        {{ $t('subscription.invoice.no_invoice.headline') }}
                                    </div>
                                </template>
                            </v-card>
                        </div>
                        <div v-else class="text-xs-center subheading pa-5 grey--text darken-1" >
                            {{ $t('subscription.no_subscription.headline') }}
                        </div>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
        <!-- Usage pop-up -->
        <usage v-model="usage_visible" :usage_visible="usage_visible"></usage>
    </div>
</template>

<script>
import { mapState} from "vuex";
import ConfirmationDialog from "@/components/ConfirmationDialog";
import Usage from "@/pages/admin/subscription/Usage"
import i18n from '@/i18n';
import * as MENU from '@/menu'
import * as HELPER from '@/helper'

export default {
    name: "AdminSubscriptionDashboard",
    data: () => ({
      headers: MENU.INVOICE_HEADERS,
      usage_visible:false,
      text:''
    }),
    components:{
        ConfirmationDialog,
        Usage
    },
    computed:{
        ...mapState({
            subscription:state => state.adminSubscription.subscription,
            paymentMethod:state => state.adminSubscription.paymentMethod,
            company:state => state.adminSubscription.company,
            invoices: state => state.adminSubscription.invoices
        })
    },
    methods:{
        getFormattedTimeString :(milliseconds, dateTimeFormat) => HELPER.getFormattedTimeString(milliseconds, dateTimeFormat),
        getPlanFormat: tiers => HELPER.getFormattedPlanDescription(tiers),
        getRemainingTime: function(){return HELPER.getRemainingTime(this.subscription)},
        cancel(flag){
            try {
                    var self = this
                    this.$store.dispatch("adminSubscription/cancel", {
                        subscription_id:this.company.subscription,
                        company_id:this.company.id,
                        cancelNow:flag
                    }).then(() => {
                        self.$store.dispatch("app/showMessage", {
                            message: i18n.t("subscription.message.canceled"),
                            color: self.DEFINES.SNACKBAR_SUCCESS_COLOR
                        })
                    })
            } catch (error) {
                self.store.dispatch("app/showMessage", {
                    message: error.message,
                    color: self.DEFINES.SNACKBAR_ERROR_COLOR
                })
            }
        },
        resume()
        {
            var self = this;
            try {
                this.$store.dispatch('adminSubscription/resume', {
                   subscription_id:this.company.subscription,
                   company_id:this.company.id,
                }).then(() => {
                    self.$store.dispatch("app/showMessage", {
                        message: i18n.t("subscription.message.reactivated"),
                        color: self.DEFINES.SNACKBAR_SUCCESS_COLOR
                    })
                })
            } catch (error) {
                self.$store.dispatch("app/showMessage", {
                    message: error.message,
                    color: self.DEFINES.SNACKBAR_ERROR_COLOR
                })
            }
        },
        getDialogAction(action,cancel_now, btn_icon, btn_color,btn_label, btn_yes_text, btn_no_text) {
            return {
                button_icon: btn_icon,
                button_color: btn_color,
                method: action == 'cancel' ? this.cancel : action == 'cancelNow' ? this.cancel : this.resume,
                payload: cancel_now,
                button_label:btn_label,
                btn_yes_text:btn_yes_text,
                btn_no_text:btn_no_text,
                btn_yes_color:btn_color,
                btn_no_color:"grey"
            };
        }
    }
}
</script>
<style scoped>
.light-bg{
    background: rgba(237, 242, 245,0.7) !important
}
.borderLeft{
    border-left: 1px solid rgba(15,15,15,0.2);
}
.displayInline{
    display: inline-block;
}
.height-zero{
    height: 0px !important;
}
</style>
